import './text';

(function($) {
    $.widget('ca.caTextarea', $.ca.caText, {
        options: {
            placeholder : '',
            placeholderClass : 'ca-textarea-placeholder'
        },
        _create : function() {
            $.ca.caText.prototype._create.call(this);
        }
    });
})(jQuery);